module.exports = __webpack_public_path__ + "img/icon_zfb.7e9dbe0f.png";